export default "/assets/llama_outlines-21d49e896d3c07cbe0624ba7c41efecc22183743e9dc266538a5826c3fdf2ef7.svg";